import IWall from 'components/interfaces/IWall';

export const BUILDING_WALL = 'building wall';
export const GLASS_WALL = 'glass wall';

const isNotUndefined = (value: any) => value != null;

export const hasElementWall = (wall: IWall): boolean =>
  isNotUndefined(wall.glazingWallType)
    ? wall.glazingWallType.toLowerCase().includes('elements')
    : false;

const wallTypes = [BUILDING_WALL, GLASS_WALL];

export default wallTypes;
